export default __webpack_public_path__ + "static/media/editPenWhite.c13f2765.svg";